/* HD Info-Seiten – Etappe 5
   Inhaltsverzeichnis + Lesefortschritt (Rechtsseiten), Suche im Hilfe-Center,
   Größenrechner, Sendungssuche, Sortierung der Suche und kleine Effekte. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var html = document.documentElement;

  function slug(t) {
    return (t || '').toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'abschnitt';
  }
  function norm(t) {
    return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  }

  /* ---------- „Kommt ins Bild" für Linien, Pfeile usw. ---------- */
  function inView(els, cb, opts) {
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (el) { el.classList.add('is-in'); cb && cb(el); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); cb && cb(e.target); io.unobserve(e.target); } });
    }, opts || { rootMargin: '0px 0px -15% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  inView(Array.prototype.slice.call(document.querySelectorAll('[data-hdx-inview]')));

  /* ---------- Licht folgt der Maus auf Karten ---------- */
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('pointermove', function (e) {
      var c = e.target.closest && e.target.closest('.hdx-card');
      if (!c) return;
      var r = c.getBoundingClientRect();
      c.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      c.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  /* ---------- Löschen-Knopf in Suchfeldern ---------- */
  document.querySelectorAll('[data-hdx-search]').forEach(function (box) {
    var inp = box.querySelector('input');
    var clr = box.querySelector('[data-hdx-clear]');
    if (!inp || !clr) return;
    var sync = function () { clr.hidden = !inp.value; };
    inp.addEventListener('input', sync);
    clr.addEventListener('click', function () { inp.value = ''; sync(); inp.focus(); inp.dispatchEvent(new Event('input', { bubbles: true })); });
    sync();
  });

  /* ==========================================================================
     Rechts- und Textseiten
     ========================================================================== */
  document.querySelectorAll('[data-hdpg]').forEach(function (root) {
    var content = root.querySelector('[data-hdpg-content]');
    var toc = root.querySelector('[data-hdpg-toc]');
    var list = root.querySelector('[data-hdpg-toc-list]');
    var bar = root.querySelector('[data-hdpg-progress]');
    var top = root.querySelector('[data-hdpg-top]');
    var title = norm(root.getAttribute('data-title'));
    if (!content) return;

    /* Überschrift doppelt? (Text beginnt mit dem Seitentitel) → ausblenden */
    var first = content.firstElementChild;
    if (first && /^H[1-3]$/.test(first.tagName) && norm(first.textContent) === title) first.remove();

    /* Inhaltsverzeichnis aus den Überschriften */
    var heads = Array.prototype.slice.call(content.querySelectorAll('h2, h3'));
    var lvl = content.querySelectorAll('h2').length >= 3 ? 'H2' : 'H3';
    var used = {};
    var items = [];
    heads.forEach(function (h) {
      var txt = h.textContent.replace(/\s+/g, ' ').trim();
      if (!txt) return;
      var id = h.id || slug(txt);
      while (used[id]) id += '-2';
      used[id] = true; h.id = id;
      if (lvl === 'H2' && h.tagName !== 'H2' && heads.length > 14) return; /* bei sehr langen Texten nur Hauptpunkte */
      items.push({ h: h, id: id, txt: txt, sub: lvl === 'H2' && h.tagName === 'H3' });
    });
    if (toc && list && items.length >= 3) {
      items.forEach(function (it) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + it.id; a.textContent = it.txt;
        if (it.sub) a.className = 'is-sub';
        li.appendChild(a); list.appendChild(li); it.a = a;
      });
      toc.hidden = false;
      root.classList.add('has-toc');
      var box = toc.querySelector('details');
      var mq = window.matchMedia('(max-width: 1099px)');
      var setOpen = function () { if (box) box.open = !mq.matches; };
      setOpen();
      if (mq.addEventListener) mq.addEventListener('change', setOpen);
      if (box) box.querySelector('summary').addEventListener('click', function (e) { if (!mq.matches) e.preventDefault(); });

      list.addEventListener('click', function (e) {
        var a = e.target.closest('a'); if (!a) return;
        var t = document.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', a.getAttribute('href'));
        if (mq.matches && box) box.open = false;
      });

      /* Aktuellen Abschnitt hervorheben */
      var current = null;
      var spy = function () {
        var y = window.innerHeight * .28, on = items[0];
        for (var i = 0; i < items.length; i++) { if (items[i].h.getBoundingClientRect().top <= y) on = items[i]; else break; }
        if (on !== current) {
          if (current && current.a) current.a.classList.remove('is-on');
          current = on;
          if (current && current.a) {
            current.a.classList.add('is-on');
            var ol = toc.querySelector('.hdpg__tocbox');
            if (ol && !mq.matches) {
              var at = current.a.offsetTop, st = ol.scrollTop, h = ol.clientHeight;
              if (at < st + 40 || at > st + h - 60) ol.scrollTop = at - h / 3;
            }
          }
        }
      };
      window.addEventListener('scroll', spy, { passive: true });
      spy();
    }

    /* Lesefortschritt + Nach-oben-Knopf */
    var tick = false;
    var onScroll = function () {
      if (tick) return; tick = true;
      requestAnimationFrame(function () {
        tick = false;
        var r = content.getBoundingClientRect();
        var total = r.height - window.innerHeight * .6;
        var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1;
        if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
        if (top) top.classList.toggle('is-on', window.scrollY > 900);
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });

    /* Druck-Knopf */
    root.querySelectorAll('[data-hdpg-print]').forEach(function (b) { b.addEventListener('click', function () { window.print(); }); });

    /* Direkt-Link auf einen Abschnitt beim Laden */
    if (location.hash.length > 1) {
      var t = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (t) setTimeout(function () { t.scrollIntoView({ block: 'start' }); }, 60);
    }
  });

  /* ==========================================================================
     Hilfe-Center
     ========================================================================== */
  document.querySelectorAll('[data-hdfaq]').forEach(function (root) {
    var input = root.querySelector('[data-hdfaq-q]');
    var count = root.querySelector('[data-hdfaq-count]');
    var empty = root.querySelector('[data-hdfaq-empty]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-hdfaq-group]'));
    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-hdfaq-cat]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-hdfaq-item]')).map(function (d) {
      var q = d.querySelector('[data-hdfaq-question]');
      return { el: d, q: q, qHtml: q.innerHTML, text: norm(d.textContent) };
    });
    var active = 'all';

    function mark(it, words) {
      if (!words.length) { it.q.innerHTML = it.qHtml; return; }
      var t = it.q.textContent;
      var re = new RegExp('(' + words.map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')', 'gi');
      it.q.innerHTML = t.replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }).replace(re, '<mark>$1</mark>');
    }

    function apply() {
      var raw = input ? input.value : '';
      var words = norm(raw).split(' ').filter(function (w) { return w.length > 1; });
      var shown = 0;
      items.forEach(function (it) {
        var inCat = active === 'all' || it.el.getAttribute('data-cat') === active;
        var hit = !words.length || words.every(function (w) { return it.text.indexOf(w) > -1; });
        var ok = inCat && hit;
        it.el.hidden = !ok;
        if (ok) shown++;
        mark(it, ok ? raw.trim().split(/\s+/).filter(function (x) { return x.length > 1; }) : []);
        if (words.length && ok && shown <= 1) it.el.open = true;
      });
      groups.forEach(function (g) { g.hidden = !g.querySelector('[data-hdfaq-item]:not([hidden])'); });
      if (empty) empty.hidden = shown > 0;
      if (count) count.textContent = words.length ? (shown === 1 ? '1 passende Antwort' : shown + ' passende Antworten') : '';
    }

    var t;
    if (input) input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(apply, 120); });
    cats.forEach(function (b) {
      b.addEventListener('click', function () {
        active = b.getAttribute('data-hdfaq-cat');
        cats.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        apply();
        var target = active === 'all' ? root.querySelector('[data-hdfaq-list]') : root.querySelector('[data-hdfaq-group="' + active + '"]');
        if (target && target.getBoundingClientRect().top < 0) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
    root.querySelectorAll('[data-hdfaq-reset]').forEach(function (b) {
      b.addEventListener('click', function () { if (input) input.value = ''; active = 'all'; cats.forEach(function (x, i) { x.classList.toggle('is-on', i === 0); }); apply(); if (input) input.focus(); });
    });

    /* Weiches Auf- und Zuklappen */
    items.forEach(function (it) {
      var sum = it.el.querySelector('summary'), body = it.el.querySelector('.hdfaq__a');
      if (!sum || !body || reduce) return;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (it.el.open) {
          var h = body.offsetHeight;
          body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 280, easing: 'cubic-bezier(.16,1,.3,1)' }).onfinish = function () { it.el.open = false; };
        } else {
          it.el.open = true;
          var h2 = body.offsetHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 380, easing: 'cubic-bezier(.16,1,.3,1)' });
        }
      });
    });

    /* ?q=… oder #frage öffnen */
    var params = new URLSearchParams(location.search);
    if (input && params.get('q')) { input.value = params.get('q'); }
    apply();
    if (location.hash.length > 1) {
      var d = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (d && d.tagName === 'DETAILS') { d.open = true; setTimeout(function () { d.scrollIntoView({ block: 'center' }); }, 80); }
    }
  });

  /* ==========================================================================
     Größen
     ========================================================================== */
  document.querySelectorAll('[data-hdsz]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hdsz-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-hdsz-panel]'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-hdsz-tab');
        tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-hdsz-panel') !== id; });
      });
    });

    panels.forEach(function (p) {
      var data;
      try { data = JSON.parse(p.querySelector('[data-hdsz-data]').textContent); } catch (e) { return; }
      var w = p.querySelector('[data-hdsz-w]'), l = p.querySelector('[data-hdsz-l]');
      var out = p.querySelector('[data-hdsz-out]'), badge = out && out.querySelector('b'), txt = out && out.querySelector('span');
      var cells = p.querySelectorAll('[data-col]');
      var idle = txt ? txt.innerHTML : '';
      var last = '';
      function calc() {
        var wv = parseFloat((w.value || '').replace(',', '.')), lv = parseFloat((l.value || '').replace(',', '.'));
        cells.forEach(function (c) { c.classList.remove('is-hit'); });
        if (!(wv > 20 && wv < 120)) { out.setAttribute('data-state', 'idle'); badge.textContent = '?'; txt.innerHTML = idle; last = ''; return; }
        /* Größe mit der passendsten Breite; bei Gleichstand die größere */
        var best = 0, diff = 1e9;
        data.w.forEach(function (x, i) { var d = Math.abs(x - wv); if (d < diff || (d === diff && i > best)) { diff = d; best = i; } });
        var size = data.s[best];
        var msg = 'Mit <strong>' + data.w[best] + ' cm</strong> Breite kommt <strong>' + size + '</strong> deinem Lieblingsteil am nächsten.';
        if (lv > 20 && data.l[best]) {
          var dl = lv - data.l[best];
          if (dl >= 4) msg += ' Dein Teil ist etwas länger (' + data.l[best] + ' cm bei ' + size + ').';
          else if (dl <= -4) msg += ' Dein Teil ist etwas kürzer (' + data.l[best] + ' cm bei ' + size + ').';
          else msg += ' Auch die Länge passt gut.';
        }
        if (wv < data.w[0] - 3) msg = 'Dein Teil ist schmaler als unsere kleinste Größe. Nimm <strong>' + data.s[0] + '</strong>.';
        if (wv > data.w[data.w.length - 1] + 3) msg = 'Dein Teil ist breiter als unsere größte Größe. Nimm <strong>' + data.s[data.s.length - 1] + '</strong> für den lockersten Sitz.';
        out.setAttribute('data-state', 'ok');
        txt.innerHTML = msg;
        p.querySelectorAll('[data-col="' + best + '"]').forEach(function (c) { c.classList.add('is-hit'); });
        if (size !== last) { badge.textContent = size; badge.classList.remove('is-pop'); void badge.offsetWidth; badge.classList.add('is-pop'); last = size; }
      }
      [w, l].forEach(function (i) { if (i) i.addEventListener('input', calc); });
    });
  });

  /* ==========================================================================
     Sendungsverfolgung: Nummer beim Paketdienst suchen
     ========================================================================== */
  document.querySelectorAll('[data-hdtr-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = f.querySelector('input');
      var n = (inp.value || '').replace(/\s+/g, '').toUpperCase();
      if (n.length < 6) { inp.focus(); inp.setAttribute('aria-invalid', 'true'); return; }
      inp.removeAttribute('aria-invalid');
      var url = f.getAttribute('data-url').replace('{n}', encodeURIComponent(n));
      window.open(url, '_blank', 'noopener');
    });
  });

  /* ==========================================================================
     Suche: Sortierung
     ========================================================================== */
  document.querySelectorAll('[data-hdsr-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      var root = sel.closest('.hdsr'); if (root) root.classList.add('is-loading');
      location.href = u.toString();
    });
  });

  /* Kontaktformular: nach dem Absenden zur Meldung springen */
  var ok = document.querySelector('[data-hdct-msg]');
  if (ok) setTimeout(function () { ok.scrollIntoView({ block: 'center' }); }, 100);
})();
